import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import App from './App.jsx'
import MotionProvider from './components/MotionProvider.jsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <MotionProvider>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </MotionProvider>
    </React.StrictMode>,
)
